export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_BRANDS':
      return { brands: action.brands };
    default:
      return state;
  }
};
